﻿import { useEffect } from 'react';
import { DeferredEvents, EventBus, useEvent } from '../../../contexts/event-bus';

// Fires deferred events for home page
export default function HomeEventProvider() {
    useEvent('deferred-event-queued', (category: keyof DeferredEvents) => {
        if (category === 'home') {
            EventBus.fireDeferredEvents('home');
        }
    });
    useEffect(() => {
        EventBus.fireDeferredEvents('home');
    }, []);

    return null;
}
